import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultants',
  templateUrl: './consultants.component.html',
  styleUrls: ['./consultants.component.css']
})
export class ConsultantsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
